import { Currency } from '@/core/currency/interfaces';

const LAK: Currency = {
    name: 'Lao Kip',
    demonym: 'Lao',
    majorSingle: 'Kip',
    majorPlural: 'Kip',
    codeNumeric: '418',
    symbol: '₭N',
    symbolNative: '₭',
    minorSingle: 'Att',
    minorPlural: 'Att',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'LAK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default LAK;
